import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { useSteleBreakpoint } from '../hooks/useBreakpoint'
import { store } from '../stores/store'
import { isAppActive, subscribeToAppBackground } from '../utils/appActivity'
import { useRunState } from './provider/useRunState'

export const VisibilityPauseBridge = observer(function VisibilityPauseBridge() {
    const runState = useRunState()
    const isStele = useSteleBreakpoint()
    const appFlowPhase = store.appFlowPhase

    useEffect(() => {
        if (isStele) return

        const pauseIfRunning = () => {
            if (appFlowPhase !== 'run') return
            runState.pause()
        }

        const syncWithActivity = () => {
            if (!isAppActive()) {
                pauseIfRunning()
            }
        }

        syncWithActivity()

        return subscribeToAppBackground(pauseIfRunning)
    }, [appFlowPhase, isStele, runState])

    return null
})
